import React from 'react';
import { useReveal } from '../lib/useReveal';
const CARDS = [{
  icon: '🔮',
  title: 'Comprender una carta natal completa',
  desc: 'Aprendé a interpretar signos, planetas, casas y aspectos para descubrir cómo se expresa la energía en cada persona.'
}, {
  icon: '🌟',
  title: 'Identificar talentos, desafíos y potencial',
  desc: 'Descubrí fortalezas naturales, aprendizajes importantes y áreas de crecimiento personal.'
}, {
  icon: '❤️',
  title: 'Comprender relaciones y emociones',
  desc: 'Interpretá patrones afectivos, necesidades emocionales y dinámicas vinculares.'
}, {
  icon: '💼',
  title: 'Descubrir vocación y propósito',
  desc: 'Aprendé a identificar tendencias profesionales, potenciales y dirección de crecimiento.'
}, {
  icon: '✨',
  title: 'Profundizar el autoconocimiento',
  desc: 'Comprendé quién sos, qué viniste a desarrollar y cómo aprovechar mejor tus recursos.'
}];
export function TransformationSection() {
  const [ref, vis] = useReveal();
  return <section className="bg-[#11152e] py-5 md:py-10 px-5 sm:px-6 border-t border-[#ffffff]/5" data-id="element-217">
      <div className="container mx-auto max-w-5xl" data-id="element-218">
        <div ref={ref} className={`reveal text-center mb-6 ${vis ? 'is-visible' : ''}`} data-id="element-219">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight text-[#f5f1e6]" data-id="element-220">
            ¿Qué vas a lograr con esta formación?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-221">
          {CARDS.map((card, i) => {
          const [cardRef, cardVis] = useReveal();
          return <div key={i} ref={cardRef} className={`reveal bg-[#1a1f3d] border border-[#d4af37]/15 rounded-2xl p-7 text-center transition-all hover:border-[#d4af37]/40 hover:shadow-lg shadow-sm ${cardVis ? 'is-visible' : ''}`} style={{
            transitionDelay: `${i * 100}ms`
          }} data-id="element-222">
                <div className="text-4xl mb-4" data-id="element-223">{card.icon}</div>
                <h3 className="text-[#f5f1e6] font-serif font-bold text-xl mb-3 leading-tight" data-id="element-224">
                  {card.title}
                </h3>
                <p className="text-[#cbd0e0] text-sm leading-relaxed" data-id="element-225">
                  {card.desc}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}